/**
 * src/shell/ui/screens/ShelfScreen.tsx — S5 卡带架 · 图鉴屏（设计稿 §1.2 S5）。
 * 成品卡带墙 → 作品详情（评审摘要）→ 沙箱试玩。
 */

import { COPY } from '../../copy'
import { useSave } from '../../gm-client/hooks'
import { SandboxFrame } from '../components/SandboxFrame'
import { DESK, type Screen } from '../nav'

export function ShelfScreen({ projectId, go }: { projectId?: string; go: (s: Screen) => void }) {
  const { bundle } = useSave()
  const completed = bundle.projects.projects
    .filter((p) => p.status === 'completed')
    .sort((a, b) => b.created_at.localeCompare(a.created_at))

  const current = projectId ? completed.find((p) => p.id === projectId) : undefined
  const review = current
    ? bundle.reviews.reviews.find((r) => r.id === current.review_id) ??
      bundle.reviews.reviews.find((r) => r.project_id === current.id)
    : undefined

  return (
    <div className="screen deep-screen">
      <button className="btn back-btn" type="button" onClick={() => go(DESK)}>
        {COPY.nav.backToDesk}
      </button>
      {!current ? (
        <div className="panel">
          {completed.length === 0 && <p className="dim">{COPY.shelf.empty}</p>}
          <div className="cartridge-wall">
            {completed.map((p) => (
              <button
                key={p.id}
                type="button"
                className="cartridge"
                onClick={() => go({ name: 'shelf', projectId: p.id })}
              >
                <span className="cartridge-label">{p.idea.slice(0, 16)}</span>
              </button>
            ))}
          </div>
        </div>
      ) : (
        <div className="panel">
          <button className="btn" type="button" onClick={() => go({ name: 'shelf' })}>
            {COPY.nav.back}
          </button>
          <h3>{current.idea}</h3>
          {review ? (
            <p className="dim">
              {COPY.review.weighted} {review.weighted_total} · {COPY.review.profit}{' '}
              {review.profit >= 0 ? '+' : ''}
              {review.profit}{' '}
              <button className="btn btn-small" type="button" onClick={() => go({ name: 'review', projectId: current.id })}>
                {COPY.computer.viewReview}
              </button>
            </p>
          ) : (
            <p className="dim">{COPY.shelf.reviewMissing}</p>
          )}
          <SandboxFrame projectId={current.id} title={current.idea} height={480} />
        </div>
      )}
    </div>
  )
}
